
export const optionsSourceBooking = [
  { value: 0, label: 'Tất nguồn đặt lịch' },
  { value: 1, label: 'Gọi điện' },
  { value: 2, label: 'FB Messenger' },
  { value: 3, label: 'Instagram' },
  { value: 4, label: 'Zalo' },
  { value: 5, label: 'Website' },
  { value: 6, label: 'Từ cơ sở' },
  { value: 7, label: 'Tiktok' }
]


export const customStylesFilter = {
  option: (provided, state) => ({
    ...provided,
    padding: 10,
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    display: "none",
  }),
  control: (provided, state) => ({
    ...provided,
    width: 120,
    textAlign: "center",
    minHeight: 32,
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";
    return { ...provided, opacity, transition };
  },
}

export const idCategory = [
  {
    id: 47,
    value: "nail",
    label: "Nails",
    color: '#f99033'
  },
  {
    id: 46,
    value: "mi",
    label: "Mi",
    color: '#f99033'
  },
  {
    id: 45,
    value: "goi",
    label: "Gội",
    color: '#f99033'
  }
]

export const idCategorySale = [
  {
    id: 4,
    value: "phun_xam",
    label: "Phun Xăm",
    color: '#e500fb',
  },
]

export const idCategoryLt = [
  {
    id: 2,
    value: "da",
    label: "Da",
    color: '#ff0000'
  },
  {
    id: 5,
    value: "triet",
    label: "Triệt",
    color: '#01bbb0'
  },
  {
    id: 4,
    value: "phun_xam",
    label: "Phun Xăm",
    color: '#e500fb',
  },
]

export const examinationList = {
  examination_goal: [
    {
      title: "Thiết lập hồ sơ ban đầu",
      value: 1
    },
    {
      title: "Đánh giá phản ứng sau buổi trước",
      value: 2
    },
    {
      title: "Đánh giá hiệu quả liệu trình",
      value: 3
    },
    {
      title: "Kiểm tra phản hồi của khách hàng",
      value: 4
    },
    {
      title: "Điều chỉnh kế hoạch điều trị",
      value: 5
    },
    {
      title: "Kiểm tra trước khi thực hiện dịch vụ",
      value: 6
    },
    {
      title: "Khác",
      value: 7
    }
  ],
  service_condition: [
    {
      key: 1,
      criteria: "Da sạch, không tổn thương",
      answer: [
        {
          title: "Bình thường",
          value: 1
        },
        {
          title: "Bất thường",
          value: 2
        }
      ],
    },
    {
      key: 2,
      criteria: "Không có vết thương hở",
      answer: [
        {
          title: "Bình thường",
          value: 1
        },
        {
          title: "Bất thường",
          value: 2
        }
      ],
    },
    {
      key: 3,
      criteria: "Không viêm da",
      answer: [
        {
          title: "Bình thường",
          value: 1
        },
        {
          title: "Bất thường",
          value: 2
        }
      ],
    },
    {
      key: 4,
      criteria: "Không kích ứng",
      answer: [
        {
          title: "Bình thường",
          value: 1
        },
        {
          title: "Bất thường",
          value: 2
        }
      ],
    },
    {
      key: 5,
      criteria: "Không bỏng nắng",
      answer: [
        {
          title: "Bình thường",
          value: 1
        },
        {
          title: "Bất thường",
          value: 2
        }
      ],
    },
    {
      key: 6,
      criteria: "Không mụn viêm vùng thăm khám",
      answer: [
        {
          title: "Bình thường",
          value: 1
        },
        {
          title: "Bất thường",
          value: 2
        }
      ],
    },
    {
      key: 7,
      criteria: "Không nhiễm trùng",
      answer: [
        {
          title: "Bình thường",
          value: 1
        },
        {
          title: "Bất thường",
          value: 2
        }
      ],
    },
    {
      key: 8,
      criteria: "Không chống chỉ định khác",
      answer: [
        {
          title: "Bình thường",
          value: 1
        },
        {
          title: "Bất thường",
          value: 2
        }
      ],
    },
  ],
  conclude_condition: [
    {
      title: "Đủ điều kiện thực hiện",
      value: 1
    },
    {
      title: "Thực hiện có điều chỉnh",
      value: 2
    },
    {
      title: "Tạm hoãn làm dịch vụ",
      value: 3
    },
    {
      title: "Không thực hiện",
      value: 4
    },
  ],
  skin_assessment: [
    {
      key: 1,
      criteria: "Loại da",
      answer: [
        {
          title: "Khô",
          value: 1
        },
        {
          title: "Dầu",
          value: 2
        },
        {
          title: "Hỗn hợp",
          value: 3
        },
        {
          title: "Bình thường",
          value: 4
        }
      ],
    },
    {
      key: 2,
      criteria: "Độ ẩm",
      answer: [
        {
          title: "Đủ",
          value: 1
        },
        {
          title: "Thiếu",
          value: 2
        }
      ],
    },
    {
      key: 3,
      criteria: "Độ nhạy cảm",
      answer: [
        {
          title: "Bình thường",
          value: 1
        },
        {
          title: "Nhạy cảm",
          value: 2
        }
      ],
    },
    {
      key: 4,
      criteria: "Màu da vùng thăm khám",
      answer: [
        {
          title: "Sáng",
          value: 1
        },
        {
          title: "Trung bình",
          value: 2
        },
        {
          title: "Ngăm",
          value: 3
        }
      ],
    },
    {
      key: 5,
      criteria: "Độ đồng đều màu da",
      answer: [
        {
          title: "Đồng đều",
          value: 1
        },
        {
          title: "Không đồng đều",
          value: 2
        }
      ],
    },
    {
      key: 6,
      criteria: "Mức độ thâm",
      answer: [
        {
          title: "Không",
          value: 1
        },
        {
          title: "Nhẹ",
          value: 2
        },
        {
          title: "Trung bình",
          value: 3
        },
        {
          title: "Nặng",
          value: 4
        }
      ],
    },
    {
      key: 7,
      criteria: "Viêm nang lông",
      answer: [
        {
          title: "Không",
          value: 1
        },
        {
          title: "Có",
          value: 2
        }
      ],
    },
    {
      key: 8,
      criteria: "Tình trạng da",
      answer: [
        {
          title: "Da khô",
          value: 1
        },
        {
          title: "Da bong tróc",
          value: 2
        },
        {
          title: "Da nổi mẩn",
          value: 3
        },
        {
          title: "Bình thường",
          value: 4
        }
      ],
    },
    {
      key: 9,
      criteria: "Mụn",
      answer: [
        {
          title: "Không",
          value: 1
        },
        {
          title: "Có",
          value: 2
        }
      ],
    },
    {
      key: 10,
      criteria: "Sẹo",
      answer: [
        {
          title: "Không",
          value: 1
        },
        {
          title: "Có",
          value: 2
        }
      ],
    },
    {
      key: 11,
      criteria: "Rạn da",
      answer: [
        {
          title: "Không",
          value: 1
        },
        {
          title: "Có",
          value: 2
        }
      ],
    }
  ],
  hair_assessment: [
    {
      key: 1,
      criteria: "Mật độ lông",
      answer: [
        {
          title: "Rất dày",
          value: 1
        },
        {
          title: "Dày",
          value: 2
        },
        {
          title: "Trung bình",
          value: 3
        },
        {
          title: "Thưa",
          value: 4
        }
      ],
    },
    {
      key: 2,
      criteria: "Độ dày sợi lông",
      answer: [
        {
          title: "Cứng",
          value: 1
        },
        {
          title: "Trung bình",
          value: 2
        },
        {
          title: "Mảnh",
          value: 3
        }
      ],
    },
    {
      key: 3,
      criteria: "Màu lông",
      answer: [
        {
          title: "Đen",
          value: 1
        },
        {
          title: "Nâu",
          value: 2
        },
        {
          title: "Vàng",
          value: 3
        },
        {
          title: "Tơ",
          value: 4
        }
      ],
    },
    {
      key: 4,
      criteria: "Chiều dài lông",
      answer: [
        {
          title: "Bình thường",
          value: 1
        },
        {
          title: "Quá ngắn",
          value: 2
        },
        {
          title: "Quá dài",
          value: 3
        }
      ],
    },
    {
      key: 5,
      criteria: "Tốc độ mọc",
      answer: [
        {
          title: "Nhanh",
          value: 1
        },
        {
          title: "Trung bình",
          value: 2
        },
        {
          title: "Chậm",
          value: 3
        }
      ],
    },
    {
      key: 6,
      criteria: "Tỷ lệ rụng sau buổi trước",
      answer: [
        {
          title: "Tốt",
          value: 1
        },
        {
          title: "Trung bình",
          value: 2
        },
        {
          title: "Chưa tốt",
          value: 3
        }
      ],
    },
    {
      key: 7,
      criteria: "Lông mọc ngược",
      answer: [
        {
          title: "Có",
          value: 1
        },
        {
          title: "Không",
          value: 2
        }
      ],
    },
  ],
  treatment_assessment: [
    {
      key: 1,
      criteria: "So với buổi trước",
      answer: [
        {
          title: "Cải thiện",
          value: 1
        },
        {
          title: "Không thay đổi",
          value: 2
        },
        {
          title: "Giảm",
          value: 3
        }
      ],
    },
    {
      key: 2,
      criteria: "Mật độ lông",
      answer: [
        {
          title: "Giảm",
          value: 1
        },
        {
          title: "Không đổi",
          value: 2
        }
      ],
    },
    {
      key: 3,
      criteria: "Mật độ lông",
      answer: [
        {
          title: "Giảm",
          value: 1
        },
        {
          title: "Không đổi",
          value: 2
        }
      ],
    },
    {
      key: 4,
      criteria: "Tốc độ mọc",
      answer: [
        {
          title: "Chậm hơn",
          value: 1
        },
        {
          title: "Không đổi",
          value: 2
        }
      ],
    },
    {
      key: 5,
      criteria: "Tình trạng da",
      answer: [
        {
          title: "Cải thiện",
          value: 1
        },
        {
          title: "Không đổi",
          value: 2
        },
        {
          title: "Giảm",
          value: 3
        }
      ],
    },
  ],
  treatment_instruction: [
    {
      key: 1,
      criteria: "Thực hiện dịch vụ",
      answer: [
        {
          title: "Có",
          value: 1
        },
        {
          title: "Không",
          value: 2
        }
      ],
    },
    {
      key: 2,
      criteria: "Điều chỉnh năng lượng",
      answer: [
        {
          title: "Giữ",
          value: 1
        },
        {
          title: "Tăng",
          value: 2
        },
        {
          title: "Giảm",
          value: 3
        }
      ],
    },
    {
      key: 3,
      criteria: "Có cần Triệt thử",
      answer: [
        {
          title: "Có",
          value: 1
        },
        {
          title: "Không",
          value: 2
        }
      ],
    }
  ],
  confirm_examination: [
    {
      title: "Đã thăm khám",
      value: 1
    },
    {
      title: "Chưa thăm khám",
      value: 2
    }
  ],
}